import { Box, Typography } from "@mui/material";
import { FaUserCircle } from "react-icons/fa";

export default function BrandDetails() {
    return (
        <>
            {/* Profile Placeholder */}
            <Box
                sx={{
                    width: 100,
                    height: 100,
                    margin: "0 auto",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    mb: 1,
                }}>
                <FaUserCircle size={70} style={{ opacity: 0.6 }} />
            </Box>

            <Typography variant="h5" fontWeight={700}>
                Digital Profile
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.75, mb: 3 }}>
                Links • Projects • Socials
            </Typography>
        </>
    );
}
